import Chip from "Components/atoms/chip"
import { AccountOffIcon, AlertCircleIcon, CheckCircleIcon } from "Components/atoms/icons"
import { EmployeeMatch } from "slices/admin/users/thunk"

interface EmployeeMatchStatusProps {
    // undefined = nothing to show, null = no matching employee
    match: EmployeeMatch | null | undefined
    isChecking: boolean
}

const EmployeeMatchStatus = ({ match, isChecking }: EmployeeMatchStatusProps) => {
    if (isChecking)
        return <Chip variant="info">Checking...</Chip>

    if (match === undefined) return null

    if (match === null)
        return <Chip variant="secondary">
            <AccountOffIcon className="me-1" />
            No matching employee — account won't be linked
        </Chip>

    const name = `${match.commonName ?? match.firstName} ${match.lastName}`

    if (match.userId)
        return <Chip variant="warning">
            <AlertCircleIcon className="me-1" />
            <strong>{name}</strong>&nbsp;is already linked to another user
        </Chip>

    return <Chip variant="success">
        <CheckCircleIcon className="me-1" />
        Will link to&nbsp;<strong>{name}</strong>&nbsp;({match.companyEmail})
    </Chip>
}

export default EmployeeMatchStatus
